import mergedPages from '../vibesites-pages.json';
import localPages from '../pages.json';

type PageData = Record<string, unknown>;

/**
 * Per-alias page data for this site: the full inheritance chain merged with
 * this repo's `pages.json`. Nav and sitemap must read this rather than a
 * parent theme's `pages.json`, or site-level `visible: false` is ignored.
 */
export const sitePages: Record<string, PageData> = (() => {
  const merged = mergedPages as Record<string, PageData>;
  const local = localPages as Record<string, PageData>;
  const result: Record<string, PageData> = {};
  for (const alias of new Set([...Object.keys(merged), ...Object.keys(local)])) {
    result[alias] = { ...merged[alias], ...local[alias] };
  }
  return result;
})();
